const ArgumentType = require('../../extension-support/argument-type');
const BlockType = require('../../extension-support/block-type');
const formatMessage = require('format-message');
const SensorPeripheral = require('../common/sensor-peripheral');
const { default: bleUtils } = require('../../util/ble');
const VirtualMachine = require('../../virtual-machine');
const { BLE_CONFIG } = require('../../util/bleCharac');


/**
 * 无线LED灯
 * 
 * @readonly
 */
const DIVECE_OPT = {
    type: 'sensor'
};

// const BLE_CONFIG = {
//     prefix: 'LM',
//     SERVICE_UUID: 0x01FF,
//     LIGHT_MODE_UUID: 0x0200,
//     ledSwitch: 0x0201,
//     ledBrightness: 0x0202,
//     FLASH_FREQUENCY_UUID: 0x0203,
//     ledFlashOnce: 0x0204,
// }
/**
 * Manage communication with a Arduino esp32 peripheral over a Scratch Link client socket.
 */
class YMLED extends SensorPeripheral {
    /**
     * Construct a Arduino communication object.
     * @param {Runtime} runtime - the Scratch runtime
     * @param {string} deviceId - the id of the extension
     * @param {string} originalDeviceId - the original id of the peripheral, like xxx_arduinoUno
     */
    constructor(runtime, deviceId, originalDeviceId) {
        super(runtime, deviceId, originalDeviceId, null, BLE_CONFIG, DIVECE_OPT);
    }
}

class ScratchYMLEDDevice {

    /**
     * @return {string} - the ID of this deivce.
     */
    get DEVICE_ID() {
        return 'ymLED';
    }

    /**
     * Construct a set of Arduino blocks.
     * @param {Runtime} runtime - the Scratch runtime.
     * @param {string} originalDeviceId - the original id of the peripheral, like xxx_arduinoUno
     */
    constructor(runtime, originalDeviceId) {
        /**
         * The Scratch runtime.
         * @type {Runtime}
         */
        this.runtime = runtime;

        // Create a new YM-LED peripheral instance
        this._peripheral = new YMLED(this.runtime, this.DEVICE_ID, originalDeviceId);
        this.bleUtils = new bleUtils();
    }

    getInfo() {
        return [{
            id: 'ymLED',
            name: formatMessage({
                id: 'YMLED.categoryName',
                default: 'YM LED',
                description: 'Label for the YM LED extension category'
            }),
            color1: "#76C75E",
            color2: "#6DB14D",
            color3: "#64A23C",
            blocks: [
                {
                    opcode: 'connect',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'YMLED.ble.connect',
                        default: 'connect to YM-LED-[DEVICE_NAME]',
                        description: 'Connect to YML Flash'
                    }),
                    arguments: {
                        DEVICE_NAME: {
                            type: ArgumentType.STRING,
                            defaultValue: ' ',
                        }
                    }
                },
                {
                    opcode: 'disConnect',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'YMLED.ble.disconnect',
                        default: 'disconnect from YML Flash',
                        description: 'Disconnect from YML Flash'
                    })
                },
                {
                    opcode: 'setLightSwitch',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'YMLED.setLightSwitch',
                        default: 'turn light [SWITCH]',
                        description: 'Turn the light on or off'
                    }),
                    arguments: {
                        SWITCH: {
                            type: ArgumentType.STRING,
                            menu: 'lightSwitch'
                        }
                    }
                },
                {
                    opcode: 'setBrightness',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'YMLED.setBrightness',
                        default: 'set brightness [BRIGHTNESS]',
                        description: 'Set the brightness of the light'
                    }),
                    arguments: {
                        BRIGHTNESS: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 50,
                            minValue: 0,
                            maxValue: 100
                        }
                    }
                },
                
                {
                    opcode: 'setFlashMode',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'YMLED.setFlashMode',
                        default: 'turn flash mode [MODE]',
                        description: 'Turn the flash mode on or off'
                    }),
                    arguments: {
                        MODE: {
                            type: ArgumentType.NUMBER,
                            menu: 'flashMode'
                        }
                    }
                },
                //插入 { opcode: '-' } 或 { type: 'separator' } 来创建分组分隔线
                 '--- Programming Interface Blocks ---',
                { type: 'separator' },
               // 编程接口组
                      
            ],
            menus: {
                lightModes: {
                   
                    items: [
                        {
                            text: formatMessage({
                                id: 'YMLED.setLightMode.1',
                                default: 'Steady On',
                                description: 'Steady On'
                            }), value: '0'
                        },
                        {
                            text: formatMessage({
                                id: 'YMLED.setLightMode.2',
                                default: 'Flashing',
                                description: 'Flashing'
                            }), value: '1'
                        },
                        {
                            text: formatMessage({
                                id: 'YMLED.setLightMode.3',
                                default: 'Breathing Light',
                                description: 'Breathing Light'
                            }), value: '2'
                        }
                    ]
                },
                lightSwitch: {
            
                    items: [
                        {
                            text: formatMessage({
                                id: 'YMLED.setLightSwitch.1',
                                default: 'On',
                                description: 'Light switch on'
                            }), value: '1'
                        },
                        {
                            text: formatMessage({
                                id: 'YMLED.setLightSwitch.0',
                                default: 'Off',
                                description: 'Light switch off'
                            }), value: '0'
                        }
                    ]
                },
                flashFrequency: {
                 
                    items: [
                        {
                            text: formatMessage({
                                id: 'YMLED.setFlashFrequency.1',
                                default: 'Fast',
                                description: 'Flash frequency be fast'
                            }), value: '1'
                        },
                        {
                            text: formatMessage({
                                id: 'YMLED.setFlashFrequency.0',
                                default: 'Slow',
                                description: 'Flash frequency be slow'
                            }), value: '0'
                        }
                    ]
                },
                flashMode: {
                  
                    items: [
                        {
                            text: formatMessage({
                                id: 'YMLED.setFlashMode.1',
                                default: 'On',
                                description: 'Flash light switch on'
                            }), value: '1'
                        },
                        {
                            text: formatMessage({
                                id: 'YMLED.setFlashMode.0',
                                default: 'Off',
                                description: 'Flash light switch off'
                            }), value: '0'
                        }
                    ]
                }
            }
        }];
    }

    async connect(args) {
        const deviceName = 'YM-LED-' + (args.DEVICE_NAME?.trim() || "");
        console.log(`Connecting to YML Flash device: ${deviceName}`);
        // Check if the device is already connected
        if (this.bleUtils.device && this.bleUtils.isConnected(this.bleUtils.device)) {
            console.log('Device is already connected');
            return;
        }
        // Attempt to connect to the device
        // Use the bleUtils to connect to the device
        try {
            await this.bleUtils.connect(deviceName, BLE_CONFIG.SERVICE_UUID);
            console.log(`Connected to device: ${deviceName}`);
        } catch (error) {
            console.error(`Failed to connect to ${deviceName}:`, error);
        }
    }

    async disConnect() {
        console.log('Disconnecting from YML Flash device');
        if (this.bleUtils.device) {
            try {
                await this.bleUtils.disConnect(this.bleUtils.device);
                console.log('Disconnected from device');
            } catch (error) {
                console.error('Failed to disconnect:', error);
            }
        }
    }

    // async setLightMode(args) {
    //     const mode = args.MODE;
    //     console.log(`Setting light mode to ${mode}`);
    //     if (this.bleUtils.device) {
    //         try {
    //             const characteristic = await this.bleUtils.getCharacteristic(this.bleUtils.service, BLE_CONFIG.LIGHT_MODE_UUID);
    //             const modeValue = parseInt(mode, 10);
    //             if (isNaN(modeValue)) {
    //                 console.error('Invalid mode value:', mode);
    //                 return;
    //             }
    //             const modeArray = new Uint8Array(1);
    //             modeArray[0] = modeValue;
    //             await this.bleUtils.writeCharacteristic(characteristic, modeArray);
    //         } catch (error) {
    //             console.error('Failed to set light mode:', error);
    //         }
    //     }
    // }

    async setLightSwitch(args) {
        const state = args.SWITCH;
        console.log(`Turning light ${state === '1' ? 'on' : 'off'}`);
        if (this.bleUtils.device) {
            try {
                const characteristic = await this.bleUtils.getCharacteristic(this.bleUtils.service, BLE_CONFIG.ledSwitch);
                const stateValue = parseInt(state, 10);
                if (isNaN(stateValue)) {
                    console.error('Invalid state value:', state);
                    return;
                }
                const stateArray = new Uint8Array(1);
                stateArray[0] = stateValue;
                await this.bleUtils.writeCharacteristic(characteristic, stateArray);
            } catch (error) {
                console.error('Failed to set light switch:', error);
            }
        }
    }

    async setBrightness(args) {
        const brightness = args.BRIGHTNESS;
        console.log(`Setting brightness to ${brightness}`);
        if (this.bleUtils.device) {
            try {
                const characteristic = await this.bleUtils.getCharacteristic(this.bleUtils.service, BLE_CONFIG.ledBrightness);
                const brightnessValue = parseInt(brightness, 10);
                if (isNaN(brightnessValue)) {
                    console.error('Invalid brightness value:', brightness);
                    return;
                }
                const brightnessArray = new Uint8Array(1);
                brightnessArray[0] = brightnessValue;
                await this.bleUtils.writeCharacteristic(characteristic, brightnessArray);
            } catch (error) {
                console.error('Failed to set brightness:', error);
            }
        }
    }

    // async setFlashFrequency(args) {
    //     const frequency = args.FREQUENCY;
    //     console.log(`Setting flash frequency to ${frequency}`);
    //     if (this.bleUtils.device) {
    //         try {
    //             const characteristic = await this.bleUtils.getCharacteristic(this.bleUtils.service, BLE_CONFIG.FLASH_FREQUENCY_UUID);
    //             const frequencyValue = parseInt(frequency, 10);
    //             if (isNaN(frequencyValue)) {
    //                 console.error('Invalid frequency value:', frequency);
    //                 return;
    //             }
    //             const frequencyArray = new Uint8Array(1);
    //             frequencyArray[0] = frequencyValue;
    //             await this.bleUtils.writeCharacteristic(characteristic, frequencyArray);
    //         } catch (error) {
    //             console.error('Failed to set flash frequency:', error);
    //         }
    //     }
    // }

    async setFlashMode(args) {
        const mode = args.MODE;
        console.log(`Turning flash mode ${mode === '1' ? 'on' : 'off'}`);
        if (this.bleUtils.device) {
            try {
                const characteristic = await this.bleUtils.getCharacteristic(this.bleUtils.service, BLE_CONFIG.ledFlashOnce);
                const modeValue = parseInt(mode, 10);
                if (isNaN(modeValue)) {
                    console.error('Invalid mode value:', mode);
                    return;
                }
                const modeArray = new Uint8Array(1);
                modeArray[0] = modeValue;
                await this.bleUtils.writeCharacteristic(characteristic, modeArray);
            } catch (error) {
                console.error('Failed to set flash mode:', error);
            }
        }
    }
}

module.exports = ScratchYMLEDDevice;